/**
 * Deck Export — Downloads pre-generated PDF or PPTX
 *
 * Each edition names its own files (`DeckEdition.downloads`). They are
 * generated offline by `scripts/generate-deck-pdf.cjs` using Puppeteer for
 * pixel-perfect, high-resolution output — a script that still lives in
 * home-ceo-mono-repo-deprecated and is run against this site's dev server —
 * then uploaded to the media bucket.
 */

import type { DeckFile } from '@components/press/pitch-deck/pitch-deck.types';

/** Where the editions' exports live in the media bucket. */
export const DECK_EXPORTS = 'https://storage.googleapis.com/the-home-ceo-media/pitch-deck';

function triggerDownload(href: string, filename: string): void {
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/* Synchronous, and deliberately not `async`.
 *
 * Neither of these awaits anything — the download is a synthetic
 * `<a download>` click and the browser takes it from there. Declaring them
 * async made the signature claim otherwise, and that claim had teeth: an
 * async function turns a synchronous throw into a rejected promise, so a
 * caller's try/catch silently misses it and it surfaces instead as a global
 * unhandled rejection with no call site attached. The one dynamic-import
 * failure production logged for this deck arrived exactly that way.
 *
 * A sync signature means a caller's try/catch works as written. */
export function downloadDeckFile(file: DeckFile): void {
  triggerDownload(file.href, file.filename);
}
